import { render } from "./ContentChapter.vue?vue&type=template&id=4eb867cf"
import script from "./ContentChapter.vue?vue&type=script&lang=js"
export * from "./ContentChapter.vue?vue&type=script&lang=js"
script.render = render

export default script